import { StandardConnect } from '@wallet-standard/features';
import { getWalletFeature } from '@wallet-standard/ui';
import { getOrCreateUiWalletAccountForStandardWalletAccount_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, getWalletForHandle_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, } from '@wallet-standard/ui-registry';
import { useCallback } from 'react';
import { useWeakRef } from '../useWeakRef.js';
/**
 * Returns a function you can call to ask the wallet to authorize the current domain to use new
 * accounts.
 */
export function useConnect(uiWallet) {
    const connectFeature = getWalletFeature(uiWallet, StandardConnect);
    const wallet = getWalletForHandle_DO_NOT_USE_OR_YOU_WILL_BE_FIRED(uiWallet);
    const connectionPromise = useWeakRef(wallet);
    const connect = useCallback(async function connect(input, ...rest) {
        if (connectionPromise.current) {
            return connectionPromise.current;
        }
        const newConnectionPromise = connectFeature
            .connect(input, ...rest)
            .then(({ accounts }) => {
            return accounts.map(getOrCreateUiWalletAccountForStandardWalletAccount_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.bind(null, wallet));
        })
            .finally(() => {
            connectionPromise.current = undefined;
        });
        connectionPromise.current = newConnectionPromise;
        return await newConnectionPromise;
    }, [connectFeature, connectionPromise, wallet]);
    const isConnecting = !!connectionPromise.current;
    return [isConnecting, connect];
}
//# sourceMappingURL=useConnect.js.map